import React, { useState, useEffect } from "react";
import { fetchAllReviews } from "../../../service/reviewService";

const StarRating = ({ rating }) => {
  const stars = Math.max(0, Math.min(5, rating));
  return (
    <div className="flex gap-0.5 text-amber-400 text-base">
      {"★".repeat(stars)}
      <span className="text-gray-300">{"★".repeat(5 - stars)}</span>
    </div>
  );
};

const CustomerReviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    fetchAllReviews()
      .then((result) => setReviews(result))
      .catch((err) => console.error("Failed to fetch reviews:", err));
  }, []);

  return (
    <section className="bg-slate-50 py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-amber-500 font-semibold text-sm uppercase tracking-widest mb-2">
            Testimonials
          </p>
          <h2 className="text-4xl font-bold text-slate-900">
            What Our Customers Say
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-7">
          {reviews.map((review) => (
            <div
              key={review?._id}
              className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col gap-4"
            >
              {/* Avatar + Name */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center text-amber-600 font-bold text-base flex-shrink-0">
                  {review?.name?.charAt(0).toUpperCase()}
                </div>
                <div>
                  <p className="font-semibold text-slate-900 text-sm">
                    {review?.name}
                  </p>
                  <StarRating rating={review?.rating} />
                </div>
              </div>

              {/* Review Text */}
              <p className="text-sm text-slate-500 leading-relaxed line-clamp-4">
                {review?.review}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CustomerReviews;
